import { render, staticRenderFns } from "./courier-orders.vue?vue&type=template&id=dc413a9c&"
import script from "./courier-orders.vue?vue&type=script&lang=js&"
export * from "./courier-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports